export const getBrowserLanguage = () => {
  const browserLang = navigator.language;
  const mainLanguage = browserLang.split('-')[0];
  if (mainLanguage === 'en' && mainLanguage !== browserLang) {
    return browserLang.split('-')[1]?.toLowerCase();
  }
  return mainLanguage;
};
